export default __webpack_public_path__ + "static/media/AI.667cd16b.svg";